import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNewspaper1"><Path d="M22 3.25342V19.3022L13 21.3022V5.25342L22 3.25342Z" fill="currentColor"/><Path d="M2 19.3022V3.25342L11 5.25342V21.3022L2 19.3022Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper1;
